import type { FC, PropsWithChildren } from 'react';

import Text from '@/components/Text';

type Props = {
  title: string;
};
const Layout: FC<PropsWithChildren<Props>> = ({ title, children }) => {
  return (
    <div className="flex  h-fit w-full max-w-5xl flex-col gap-5 rounded-2xl bg-jb-neutral-100 p-6">
      <Text className="font-semibold text-jb-neutral-1000" variant="h5">
        {title}
      </Text>
      {children}
    </div>
  );
};

export default Layout;
